import { useEffect, useState } from "react"
import ShowAccordion from "./showAccordion"
import ShowGrid from "./showGrid"
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../../utils/decodeHtml";
import { retrunAssets } from "../../../utils/getAssets";

const FacilitiesAtKSHAS = ({ training }) => {

    const header = training?.header2

    const [accordion, setAccordion] = useState([])



    useEffect(() => {
        if (training?.accordions2?.items) {
            const acc = training.accordions2.items;

            const formattedAccordion = acc.map((item) => {
                const properties = item?.content?.properties;

                const data = properties?.Details?.items?.map((d, idx) => {
                    const detailProperties = d?.content?.properties;
                    if (properties) {
                        return {
                            text: detailProperties?.thumbnailLabel ?? "",
                            img: retrunAssets(detailProperties?.thumbnailImage?.[0]?.url) ?? "",
                            children: (
                                <div key={idx} className="flex flex-col gap-5 w-full p-8 max-h-[80vh] max-w-[80vw] overflow-y-auto scroll-bar">
                                    <h1 className="text-zinc-950 text-xl sm:text-3xl font-bold">{detailProperties?.DescriptionHeader}</h1>
                                    <p className="w-auto text-justify text-[1.13rem] font-medium ">
                                        <DecodeHtml html={detailProperties?.description?.markup} />
                                    </p>
                                    <div className="grid grid-cols-1 md:grid-cols-2 place-items-center gap-5">
                                        {detailProperties?.descriptionImages?.map((img, index) => (
                                            <img key={index} className="bg-gray-200 max-w-full h-[32rem] object-cover" src={retrunAssets(img?.url)} alt="" />
                                        ))}
                                    </div>
                                </div>
                            )
                        };
                    }

                });
                return {
                    question: properties?.header ?? "",
                    answer: <ShowGrid cards={data} />,
                    open: false
                };

            });

            setAccordion(formattedAccordion);
        }
    }, [training?.accordions2?.items]);


    return (
        <ShowAccordion title={header} accordion={accordion} setAccordion={setAccordion} />
    )

}
FacilitiesAtKSHAS.propTypes = {
    training: PropTypes.any
}
export default FacilitiesAtKSHAS